<!--====== TEAM PART START ======-->

    <section id="team" class="team-area pt-125 pb-130 gray-bg">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="section-title text-center pb-20">
                        <h5 class="sub-title mb-15">Meet The Team</h5>
                        <h2 class="title">Our Expert Manpower</h2>
                    </div> <!-- section title -->
                </div>
            </div> 
            
            <div class="row mt-80 text-center d-flex justify-content-center">
            <div data-aos="fade-left" class="col-lg-3 padding-0 text-center">
                <img
                    class="img-fluid"
                    src="/assets/images/team/member1.png"
                    alt="..."
                />
            </div>
            <div data-aos="fade-right" class="col-lg-6 padding-0">
                <div class="h-100 text-center">
                    <div class="d-flex h-100">
                        <div
                            class="project-text w-100 my-auto text-center"
                        >
                            <h2 class="text-black mb-2">Arfino S.T</h2>
                            <!-- <p class=" mt-2 text-black-50 mx-4">
                                To become a leading export trading company by exporting local products from Indonesian Farmer and together we improve national economy.
                            </p> -->
                            <h4>Director
                            </h4>
                            <div class="footer-logo">
                            <ul class="footer-social mt-20">
                                <li><a href="https://mail.google.com/mail/?view=cm&fs=1&to=coconusakhatulistiwa@gmail.com" target="blank"><i class="lni-google"></i></a></li>
                                <li><a href="#"><i class="lni-instagram"></i></a></li>
                            </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-80 text-center d-flex justify-content-center">
            <div data-aos="fade-right" class="col-lg-4 padding-0 text-center">
                <img
                    class="img-fluid"
                    src="/assets/images/team/member2.png"
                    alt="..."
                />
            </div>
            <div data-aos="fade-left" class="col-lg-6 order-lg-first padding-0">
                <div class="text-center h-100 project">
                    <div class="d-flex h-100">
                        <div
                            class="project-text w-100 my-auto text-center"
                        >
                            <h2 class="text-black mb-2">Akbar Saktian Maulana</h2>
                            <!-- <p class="mb-0 mt-2 text-black-50 mx-4">
                                Provide trust and service to achieve customer satisfaction
                            </p>
                            <p class="mb-0 mt-0 text-black-50 mx-4">
                            Applying a quality management system to create best quality products
                            </p>
                            <p class="mb-2 mt-0 text-black-50 mx-4">
                            Creating network partnerships between companies and customers
                            </p> -->
                            <h4>Beneficial Owner
                            </h4>
                            <div class="footer-logo">
                            <ul class="footer-social mt-20">
                                <li><a href="https://mail.google.com/mail/?view=cm&fs=1&to=coconusakhatulistiwa@gmail.com" target="blank"><i class="lni-google"></i></a></li>
                                <li><a href="#"><i class="lni-instagram"></i></a></li>
                            </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
        </div> <!-- container -->
    </section>

    <!--====== TEAM PART ENDS ======-->

    <style>
    .order-lg-first {
    order: -1 !important;
  }
  .padding-0{
      padding-left: 0;
      padding-right: 0;
  }
</style>